import {gql} from 'graphql-request';

const UPDATE_WEDDING_WEBSITE_MUTATION = gql`
  mutation UpdateWeddingWebsite($attributes: WeddingWebsiteAttributes!) {
    updateWeddingWebsite(attributes: $attributes) {
      registryNote
    }
  }
`;

export default UPDATE_WEDDING_WEBSITE_MUTATION;
